import React from 'react';
import { HelpCircleIcon } from 'lucide-react';
import { Reveal } from './ui/Reveal';
import { PRODUCT_TM, questions } from '../data/content';
export function ProblemSection() {
  return <section aria-labelledby="problema" className="bg-mist" data-id="element-156" data-mp="30gxw22wbfppe">
      <div className="mx-auto max-w-page px-3 py-5 text-center sm:px-6 sm:py-7" data-id="element-157" data-mp="30iis5wya3gpd">
        <Reveal data-id="element-158" data-mp="2vowmioqj8d32">
          <h2 id="problema" className="mx-auto max-w-3xl font-display text-lg uppercase leading-[1.06] text-navy sm:text-2xl lg:text-3xl" data-id="element-159" data-mp="2voegx1hzcmih">
            ¿Te gustaría entrar al mundo de la energía solar, pero no sabes por
            dónde empezar?
          </h2>
          <p className="mx-auto mt-1 max-w-2xl font-body text-[0.8rem] leading-snug text-steel sm:text-sm" data-id="element-160" data-mp="3jfadebxds5w2">
            Tal vez ya viste videos, descargaste manuales o buscaste información
            sobre paneles solares...{' '}
            <span className="font-bold text-azure" data-id="element-161" data-mp="1k37nojy5yf9y">
              Pero todavía tienes preguntas:
            </span>
          </p>
        </Reveal>

        <ul className="mx-auto mt-2.5 grid max-w-4xl gap-1.5 sm:grid-cols-2" data-id="element-162" data-mp="jeetougupvlp">
          {questions.map((q, i) => <Reveal key={q} as="li" delay={i * 0.03} className="flex items-center gap-2 rounded-md border-l-4 border-azure bg-white px-2.5 py-2 text-left font-body text-[0.78rem] font-semibold text-navy sm:text-[0.82rem]" data-id="element-163" data-mp="ocg8h378v8rd" data-mpi={i}>
              <HelpCircleIcon size={15} className="flex-shrink-0 text-azure" strokeWidth={2.5} data-id="element-164" data-mp="123cz4ohm1fvs" />
              {q}
            </Reveal>)}
        </ul>

        <Reveal delay={0.08} className="mx-auto mt-3 max-w-3xl" data-id="element-165" data-mp="1bzy6vhl0l53b">
          <p className="font-body text-[0.8rem] leading-snug text-steel sm:text-sm" data-id="element-166" data-mp="1g2ugiisktqv4">
            El problema no es la falta de información.{' '}
            <span className="font-bold text-navy" data-id="element-167" data-mp="3hur08fowe70z">
              Es tener demasiada información dispersa y ninguna ruta clara para
              aprenderla.
            </span>
          </p>
          <p className="mt-1 font-body text-[0.8rem] leading-snug text-steel sm:text-sm" data-id="element-168" data-mp="p23k90uhmsgi">
            {PRODUCT_TM} organiza los conocimientos fundamentales en un
            recorrido progresivo pensado para principiantes, electricistas y
            emprendedores.
          </p>
          <p className="mt-1.5 font-script text-2xl text-azure sm:text-3xl" data-id="element-169" data-mp="ty288nbwm8ge">
            Comprende. Calcula. Planifica. Avanza.
          </p>
        </Reveal>
      </div>
    </section>;
}